import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {Link, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getDlogs} from "../../store/reducers/DlogSlice";
import DlogSearch from "./components/DLogSearch";
import {DlogTable} from "./components/DLogTable";

interface DlogScreenProps {
}

export const DlogScreen: React.FC<DlogScreenProps> = () => {

    const dispatch = useAppDispatch();
    const routeParams = useParams();

    useEffect(() => {
        dispatch(getDlogs({ timeFrom: '', timeTo: '' }));
    }, [routeParams]);

    return (
        <LoggedInView fullWidth={false}>
            <DlogSearch />
            <DlogTable />
        </LoggedInView>
    )
}

